import useVisible from '@/shared/hooks/useVisible';
import { Modal } from '@/shared/ui';
import * as Dialog from '@radix-ui/react-dialog';
export const CopyrightButton = () => {
    const [copyRightVisible, setCopyRightVisible] = useVisible();

    return (
        <>
            <Modal
                open={copyRightVisible}
                onClose={setCopyRightVisible}
                title="저작권 안내"
                isCustom={true}
            >
                <div className="pop_wrap pop_size8 copyright_wrap">
                    <div className="modal_header">
                        <div className="title">저작권 안내</div>
                    </div>
                    <div className="pop_contents type-padding4">
                        <div className="text-cont">
                            본 사이트에서 수업 자료로{' '}
                            <strong className="txt_point2">
                                이용되는 저작물은 저작권법 제 25조 수업 목적 저작물 이용보상금 제도
                            </strong>
                            에 의거,
                            <br />
                            <strong className="txt_point2">
                                한국문학예술저작권협회와 약정을 체결
                            </strong>
                            하고 적법하게 이용하고 있습니다.
                            <br /> 약정 범위를 초과하는 사용은 저작권법에 저촉될 수 있으므로 수업
                            자료의 대중 공개 · 공유 및 수업 목적 외의 사용을 금지합니다.
                        </div>
                    </div>
                    <Dialog.Close asChild>
                        <button type="button" className="btn-x btn-x-white">
                            <span className="sr-only">팝업 닫기</span>
                        </button>
                    </Dialog.Close>
                </div>
            </Modal>
            <button type="button" onClick={setCopyRightVisible}>
                <i className="base-icon icon-question-mark ">
                    <span className="sr-only">팝업</span>
                </i>
                &nbsp;저작권 안내
            </button>
        </>
    );
};
